
export default class ReportTasksSummaryByUser_Settings {

    public userId        : ID | null
    public showClosed    : boolean

    constructor(data: any) {
        this.userId        = _.get(data, "userId", null)
        this.showClosed    = _.get(data, "showClosed", false)
    }

    toJSON(): JSONObject {
        const result: JSONObject = {
            userId        : this.userId,
            showClosed    : this.showClosed,
        }

        return result
    }
}
